import React from 'react';
import {withStrictMode} from '@wix/wixstores-client-common-components/dist/es/src/HOC/strictMode';
import {withStyles} from '@wix/native-components-infra/dist/es/src/HOC/withStyles/withStyles';

export const bootstrapApp = (Component: React.ComponentType) => {
  return withStyles(withStrictMode(Component), {});
};
